import { ErrorHandler, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PHBHPLayoutPackageModule } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { PHBHPLocalizePackageModule } from 'ph-bhp-feature-packages/ph-bhp-localize-package/public_api';
import { ClientLibModule } from 'ph-bhp-feature-packages/ph-bhp-feature-package-check/public_api';
import { PhBhpFeatureComponentsModule } from 'ph-bhp-feature-packages/ph-bhp-feature-components/public_api';

import { GridModule } from '@progress/kendo-angular-grid';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthorizationModule } from './Authorization/authorization.module';
import { SopModule } from './SOPManagement/sop.module';
import { PHBHPFeaturePackageObserveObservationModule } from './ObserveObservation/ph-bhp-feature-package-observe-observation.module';
import { PHBHPFeaturePackageConfigurationModule } from './configure/ph-bhp-feature-package-configuration.module';
import { PHBHPFeaturePackageConsumptionModule } from './Consumption/ph-bhp-feature-package-consumption.module';
import { PHBHPFeaturePackageUserManagementModule } from './user/ph-bhp-feature-package-user-management.module';
import { PHBHPFeaturePackageInsitutionManagementModule } from './institution/ph-bhp-feature-package-insitution-management.module';
import { PhBhpFeaturePackageSopobservationModule } from './SOPObservation/ph-bhp-feature-package-sopobservation.module';
import { ElearningModule } from './elearning/elearning.module';
import { LayoutModule } from './layout/layout.module';
import { DashboardModule } from './dashboard/dashboard.module';
import { EvaluationModule } from './evaluation/evaluation.module';
import { PHBHPFeaturePackageChcModule } from './chc/ph-bhp-feature-package-chc.module';
import { PagesModule } from './Pages/pages.module';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { TooltipModule as BsTooltipModule } from 'ngx-bootstrap/tooltip';
import { MyTaskModule } from './myTask/myTask.module';
import { ImportStationsComponent } from './import-stations/import-stations.component';
import { MonitoringErrorHandlerService } from "./services/monitoring-error-handler.service";
import { MigrationToolComponent } from './migration-tool/migration-tool.component';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from 'src/environments/environment';
import { MissingTranslationHandler, MissingTranslationHandlerParams, TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { ToastService } from './services/toast.service';
import { MatIconRegistry } from '@angular/material/icon';
import { PHBHPFeaturePackageCheckModule } from './check/hygiene-check-package.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTableModule } from '@angular/material/table';
import { HygieneCheckMenuComponent } from './check/hygiene-check-menu/hygiene-check-menu.component';
import { MultiTranslateLoader } from './i18n/multi-translate-loader';


export function createMultiTranslateLoader(http: HttpClient) {
  return new MultiTranslateLoader(http, [
    { prefix: environment.apiUrl + '/api/Translation/', suffix: '' },
    { prefix: environment.check.api_url + 'Translations/', suffix: '' }
  ]);
}

export class MyMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams) {
      if (params.key.startsWith('SOP_')) {
          return '';
      } else {
          return params.key;
      }
  }
}

@NgModule({
    declarations: [
        AppComponent,
        ImportStationsComponent,
        MigrationToolComponent,
        HygieneCheckMenuComponent
    ],
    imports: [
        LayoutModule,
        MyTaskModule,
        PHBHPFeaturePackageConfigurationModule,
        PHBHPFeaturePackageChcModule,
        PHBHPFeaturePackageObserveObservationModule,
        PHBHPFeaturePackageConsumptionModule,
        PHBHPFeaturePackageUserManagementModule,
        PHBHPFeaturePackageInsitutionManagementModule,
        PhBhpFeaturePackageSopobservationModule,
        AppRoutingModule,
        PHBHPLayoutPackageModule,
        GridModule,
        BrowserAnimationsModule,
        AuthorizationModule,
        SopModule,
        ElearningModule,
        PHBHPLocalizePackageModule,
        ClientLibModule.forRoot({
          api_url: environment.check.api_url,
          signInUrl: environment.check.signInUrl,
          refreshTokenUrl: environment.check.refreshTokenUrl,
          apiHartmannUrl: environment.check.apiHartmannUrl,
        }),
        PhBhpFeatureComponentsModule,
        PHBHPFeaturePackageCheckModule,
        //SopObserveModule,
        EvaluationModule,
        DashboardModule,
        ButtonsModule,
        TooltipModule,
        BsTooltipModule.forRoot(),
        PagesModule,
        TranslateModule.forRoot({
            missingTranslationHandler: { provide: MissingTranslationHandler, useClass: MyMissingTranslationHandler },
            loader: {
                provide: TranslateLoader,
                useFactory: createMultiTranslateLoader,
                deps: [HttpClient]
            }
        }),
        MatDatepickerModule,
        MatNativeDateModule,
        MatFormFieldModule,
        MatTableModule
    ],
    providers: [
        { provide: ErrorHandler, useClass: MonitoringErrorHandlerService },
        ToastService
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
  constructor(iconRegistry: MatIconRegistry) {
    iconRegistry.setDefaultFontSetClass('material-icons-outlined');
  }
}

